import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { isLoggedIn, isVerifyEmail, userToken, logout } from "../../../features/user";
import { setLoading, showMessage} from "../../../features/common";
import axios from "axios";
import { API_200, API_204, API_URL, DEFAULT_ERROR_TEXT, API_EXCEPTION } from '../../../Constants';
import {Trans,  useTranslation } from 'react-i18next';
import {checkApiSessionErrorMessage, checkValidToken, userLoggedIn, getLang, arrayBufferToBase64, navigateTo, showLoading } from "../../../Helper"

import Frame from '../../widgets/Frame';
import Background from '../../widgets/Background';
import Input from '../../widgets/Input';
import DateInput from '../../widgets/DateInput';
import TextArea from '../../widgets/TextArea';
import CheckBox from '../../widgets/CheckBox';
import ImagePicker from '../../widgets/ImagePicker';
import Specialization from '../../widgets/Specialization';


export function EditProviderProfile() {
    const [state, setState] = useState({provider:null, errors:{}, showDatePicker:false, showImagePicker:false, showAccountDeletionPopup:false, showAccountDeletionCode:false, accountDeletionCode:''});

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);

    useEffect(()=>{
        (async () => {
            await checkValidToken(navigate, dispatch, false, true, '/start');
            if(userLoggedIn(isUserLoggedIn, isUserVerifyEmail, navigate, dispatch)){
                getProvider();
            }
        })();
        // eslint-disable-next-line
    },[]);

    const getProvider = async () => {
        showLoading(dispatch, true);
        let errorMessage = DEFAULT_ERROR_TEXT;

        let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};

        try {
            const reply = await axios.get(`${API_URL }/provider/`, config);
            showLoading(dispatch, false);
            // console.log(reply.data.dateOfBirth);
            if(reply.hasOwnProperty('data') && reply.hasOwnProperty('status') && reply.status === API_200) {
                if(reply.data.avatar && reply.data.avatar.length === 1) {
                    reply.data.avatar = reply.data.avatar[0];
                }

                setState({
                    ...state,
                    provider: reply.data
                });
            }
        } catch (e) {
            showLoading(dispatch, false);
            dispatch(showMessage({message : errorMessage}));
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!validateForm()) {
            showLoading(dispatch, true);
            let errorMessage = DEFAULT_ERROR_TEXT;
            
            let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};
          
            const data = {firstName: state.provider.firstName.trim(), lastName: state.provider.lastName.trim()/*, dateOfBirth: state.provider.dateOfBirth*/, geographicLocation: state.provider.geographicLocation, summary: state.provider.summary, serviceExplanation: state.provider.serviceExplanation, description: state.provider.description, specialization: state.provider.specialization, genre: state.provider.genre, language: state.provider.language, media: state.provider.media, previousProjects: state.provider.previousProjects, avatar: state.provider.avatar};

            try {
                const reply = await axios.patch(API_URL + '/provider', data, config);
                showLoading(dispatch, false);
                if(reply.hasOwnProperty('status') && reply.status === API_204) {
                    //navigateTo(dispatch, navigate, "/provider");
                    //navigateTo(dispatch, navigate, -1);
                }
            } catch (e) {
                showLoading(dispatch, false);
                if(e?.response?.data?.hasOwnProperty("errors") && e.response.data["errors"].length > 0){
                    errorMessage = e.response.data["errors"][0];
                }
                if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate, true)) {
                    dispatch(showMessage({message : errorMessage}));
                }
            }
        } else {
            dispatch(showMessage({message : 'please_fill_input'}));
        }

    };

    const handleChange = (e) => {
        change(e.target.id, e.target.value);
    };

    const change = (id, value) => {
        delete state.errors[id];
        setState({
            ...state, 
            provider:{...state.provider,
                [id]: value,
            },
            errors: {...state.errors},
        });
    };

    const changeList = (listName, id) => {
        let list = state.provider[listName]?? {};
        if(list && list[id]) {
            delete list[id];
        } else {
            list = {...list, [id]: id};
        }
        change(listName, list);
        //return list;
    };

    const changeGenre = (id) => {
        changeList('genre', id);
    };

    const changeLanguage = (id) => {
        changeList('language', id);
    };

    const changeSpecialization = (id) => {
        changeList('specialization', id);
    };


    const changeGroup = (groupName, id, value) => {
        let group = state.provider[groupName]?? {};
        group = {...group, [id]: value};
        change(groupName, group);
        //return list;
    };

    const changeMedia = (e) => {
        changeGroup('media', e.target.id, e.target.value);
    };


    

    const toggleImagePicker = () => {
        setState({
            ...state,
            showImagePicker: !state.showImagePicker,
        });
    };


    const setAvatarImage = (image) => {
        setState({
            ...state,
            showImagePicker: false,
            provider:{...state.provider,
                ['avatar']: image,
            },
        });

    }

    const validateForm = () => {
        const errors = {};
        if (!state.provider.firstName?.trim()) {
            errors['firstName'] = 'first_name_error';
        }

        if (!state.provider.lastName?.trim()) {
            errors['lastName'] = 'last_name_error';
        }

        if (!state.provider.summary?.trim()) {
            errors['summary'] = 'provider_summary_error';
        }

        if (Object.keys(state.provider.specialization).length < 1) {
            errors['specialization'] = 'specialization_error';
        }

        /*if (!state.provider.dateOfBirth) {
            errors['dateOfBirth'] = 'dote_of_birth_error';
        }*/

        setState({
            ...state,
            errors: errors,
        });

        return Object.keys(errors).length > 0;
    };


    const showAccountDeletionClick = (show) => {
        setState({
            ...state,
            showAccountDeletionPopup: show,
            showAccountDeletionCode: false,
            accountDeletionCode:''
        });
    }

    const handleCodeChange = (e) => {
        setState({
            ...state,
            accountDeletionCode: e.target.value
        });
    }

    const handleAccountDeletion = async () => {
        let errorMessage = DEFAULT_ERROR_TEXT;
        
        const data = {code:state.accountDeletionCode?state.accountDeletionCode.trim():null};
        let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}, data: data};

        try {
            const reply = await axios.delete(API_URL + '/providers/deleteaccount', config);
            console.log(reply);
            if(reply.hasOwnProperty('status') && reply.status === API_204) {
                if(!state.showAccountDeletionCode) {
                    setState({
                        ...state,
                        showAccountDeletionCode: true,
                        accountDeletionCode:''
                    });
                } else {
                    setState({
                        ...state,
                        showAccountDeletionPopup: false,
                        showAccountDeletionCode: false,
                        accountDeletionCode:''
                    });
                    dispatch(logout());
                    navigate('/start')
                }
            }
        } catch (e) {
            if(e?.response?.data?.hasOwnProperty("errors") && e.response.data["errors"].length > 0){
                errorMessage = e.response.data["errors"][0];
            }
            if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate, true)) {
                dispatch(showMessage({message : errorMessage}));
            }
        }
    };

    

    const accountDeletionPopup =() => {
        return (
            <div className='user-popup account-deletion-popup'>
                <img className='user-popup-image mt20' src={'/images/account_deletion.png'}  alt=''/>
                <div className='font-30 font-bold mr20 ml20 mt10'>{t('account_deletion')}</div>
                {!state.showAccountDeletionCode && <>
                    <div className='font-15 mr20 ml20 mt20'>{t('account_deletion_message')}</div>
                    <div className='popup-button small mt20 mb20' onClick={()=>handleAccountDeletion()}>{t('yes_i_am_sure')}</div>
                </>}
                {state.showAccountDeletionCode && <>
                    <div className='font-15 mr20 ml20 mt20'>{t('account_deletion_code_message')}</div>
                    <div className='mt10 width-90'>
                        <Input id="accountDeletionCode" placeholder={t("verification_code")} value={state.accountDeletionCode??''} onChange={(e) => handleCodeChange(e)}/>
                    </div>
                    <div className='popup-button small mt40 mb20' onClick={()=>handleAccountDeletion()}>{t('delete_my_account')}</div>
                </>}
                <img className='close-icon' src={'/images/close_x.png'} onClick={()=>showAccountDeletionClick(false)} alt=''/>
            </div>
        )
    }


    return (
        <Frame showMenu={true} showNav={true}>
            <div className='main main-provider-profile'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                        {state.provider?<Background showClouds={true} >
                            <div className='right-main-inner'>
                                <div className='center-div relative mt60'>
                                    <div className='center-div' onClick={()=>toggleImagePicker()}>
                                        <img src={state.provider.avatar?'/images/avatar.png':'/images/photo_upload.png'} className='avatar-border' alt=''/>
                                        <div className='avatar-div'>
                                            {state.provider.avatar && <img src={arrayBufferToBase64(state.provider.avatar)} className='avatar' alt=''/>}
                                        </div>
                                    </div>
                                </div>

                                <div className='image-picker'>
                                    {state.showImagePicker && 
                                        <ImagePicker title={t('choose_profile_picture')} onSelected={(image)=>setAvatarImage(image)} onCancel={()=>toggleImagePicker()} avatar={true}/>
                                    }
                                </div>

                                <div className='mt30'>
                                    <Input className={state.errors.firstName?"error":""} id="firstName" placeholder={t("first_name")} value={state.provider.firstName??''} onChange={(e) => handleChange(e)}/>
                                </div>
                                {state.errors.firstName && <div className='mt5 error font-12'><Trans i18nKey={state.errors.firstName} /></div>}

                                <div className='mt30'>
                                    <Input className={state.errors.lastName?"error":""} id="lastName" placeholder={t("last_name")} value={state.provider.lastName??''} onChange={(e) => handleChange(e)}/>
                                </div>
                                {state.errors.lastName && <div className='mt5 error font-12'><Trans i18nKey={state.errors.lastName} /></div>}


                                {/*<div className='mt25'>
                                    <DateInput id="dateOfBirth" placeholder={t("dote_of_birth")} value={state.provider.dateOfBirth} readOnly={true} onChange={(date) => change('dateOfBirth', date)} />
                                </div>*/}

                                <div className='mt30'>
                                    <Input className={state.errors.geographicLocation?"error":""} id="geographicLocation" placeholder={t("geographic_location")} value={state.provider.geographicLocation??''} onChange={(e) => handleChange(e)}/>
                                </div>

                                <div className='mt30'>
                                    <TextArea className={state.errors.summary?"error":""} id="summary" placeholder={t("provider_summary")} footer={t('up_to_200_characters')} value={state.provider.summary??''} onChange={(e) => handleChange(e)}/>
                                </div>
                                {state.errors.summary && <div className='mt5 error font-12'><Trans i18nKey={state.errors.summary} /></div>}

                                <div className='mt5'>
                                    <div className='center-div font-12 text-align-center'>{t("short_info_explanation")}</div>
                                </div>

                                <Specialization specialization={state.provider.specialization} changeSpecialization={(id) => changeSpecialization(id)} errors={state.errors}></Specialization>

                                <div className='mt30'>
                                    <TextArea className={state.errors.serviceExplanation?"error":""} id="serviceExplanation" placeholder={t("short_explanation_about_your_work")} footer={t('up_to_500_words')} value={state.provider.serviceExplanation??''} onChange={(e) => handleChange(e)}/>
                                </div>


                                <div className='mt30'>
                                    <div className='center-div font-25 font-bold text-align-center'>{t("genres_you_specializing_in")}</div>
                                </div>

                                <div className='mt10 flex justify-content-space-between align-items-center'>
                                    <div className='font-25'>{t("genre")}</div>
                                    <div className='font-15'>{t("select_options")}</div>
                                </div>
                                

                                <div className='mt10 font-15 flex'>
                                    <div className='font-15 flex flex-direction-column width-50'>
                                        <div className='mt10'><CheckBox id='horror' text={t('horror')} value={state.provider.genre?.horror} onChange={(id) => changeGenre(id)} /></div>
                                        <div className='mt10'><CheckBox id='scifi' text={t('scifi')} value={state.provider.genre?.scifi} onChange={(id) => changeGenre(id)} /></div>
                                        <div className='mt10'><CheckBox id='young_adult_literature' text={t('young_adult_literature')} value={state.provider.genre?.young_adult_literature} onChange={(id) => changeGenre(id)} /></div>
                                        <div className='mt10'><CheckBox id='prose' text={t('prose')} value={state.provider.genre?.prose} onChange={(id) => changeGenre(id)} /></div>
                                        <div className='mt10'><CheckBox id='romantics' text={t('romantics')} value={state.provider.genre?.romantics} onChange={(id) => changeGenre(id)} /></div>
                                    </div>

                                    <div className='font-15 flex flex-direction-column width-50'>
                                        <div className='mt10'><CheckBox id='adventure' text={t('adventure')} value={state.provider.genre?.adventure} onChange={(id) => changeGenre(id)} /></div>
                                        <div className='mt10'><CheckBox id='thriller' text={t('thriller')} value={state.provider.genre?.thriller} onChange={(id) => changeGenre(id)} /></div>
                                        <div className='mt10'><CheckBox id='fantasy' text={t('fantasy')} value={state.provider.genre?.fantasy} onChange={(id) => changeGenre(id)} /></div>
                                        <div className='mt10'><CheckBox id='historical_fiction' text={t('historical_fiction')} value={state.provider.genre?.historical_fiction} onChange={(id) => changeGenre(id)} /></div>
                                        <div className='mt10'><CheckBox id='poetry' text={t('poetry')} value={state.provider.genre?.poetry} onChange={(id) => changeGenre(id)} /></div>
                                        <div className='mt10'><CheckBox id='other' text={t('other')} value={state.provider.genre?.other} onChange={(id) => changeGenre(id)} /></div>
                                    </div>
                                </div>

                                <div className='mt30'>
                                    <div className='center-div font-25 font-bold text-align-center'>{t("what_languages_do_you_speak")}</div>
                                </div>


                                <div className='mt10 font-15 flex'>
                                    <div className='font-15 flex flex-direction-column width-50'>
                                        <div className='mt10'><CheckBox id='hebrew' text={t('hebrew')} value={state.provider.language?.hebrew} onChange={(id) => changeLanguage(id)} /></div>
                                        <div className='mt10'><CheckBox id='russian' text={t('russian')} value={state.provider.language?.russian} onChange={(id) => changeLanguage(id)} /></div>
                                        <div className='mt10'><CheckBox id='german' text={t('german')} value={state.provider.language?.german} onChange={(id) => changeLanguage(id)} /></div>
                                    </div>

                                    <div className='font-15 flex flex-direction-column width-50'>
                                        <div className='mt10'><CheckBox id='english' text={t('english')} value={state.provider.language?.english} onChange={(id) => changeLanguage(id)} /></div>
                                        <div className='mt10'><CheckBox id='spanish' text={t('spanish')} value={state.provider.language?.spanish} onChange={(id) => changeLanguage(id)} /></div>
                                        <div className='mt10'><CheckBox id='french' text={t('french')} value={state.provider.language?.french} onChange={(id) => changeLanguage(id)} /></div>
                                     </div>
                                </div>


                                <div className='mt30'>
                                    <div className='font-20'>{t("media_option_to_contacting_you")}</div>
                                </div>


                                <div className='mt30'>
                                    <Input className={state.errors.whatsapp?"error":""} id="whatsapp" placeholder={t("whatsapp")} value={state.provider.media?.whatsapp??''} onChange={(e) => changeMedia(e)}/>
                                </div>

                                <div className='mt30'>
                                    <Input className={state.errors.email?"error":""} id="email" placeholder={t("email")} value={state.provider.media?.email??''} onChange={(e) => changeMedia(e)}/>
                                </div>

                                <div className='mt30'>
                                    <Input className={state.errors.facebook?"error":""} id="facebook" placeholder={t("facebook")} value={state.provider.media?.facebook??''} onChange={(e) => changeMedia(e)}/>
                                </div>

                                <div className='mt30'>
                                    <Input className={state.errors.instagram?"error":""} id="instagram" placeholder={t("instagram")} value={state.provider.media?.instagram??''} onChange={(e) => changeMedia(e)}/>
                                </div>


                                <div className='mt30'>
                                    <Input className={state.errors.previousProjects?"error":""} id="previous_projects" placeholder={t("previous_projects")} value={state.provider.previousProjects??''} onChange={(e) => changeMedia(e)}/>
                                </div>

                                

                                <div className='button-form mt20' onClick={(e) => handleSubmit(e)}>  <div>{t("edit")}</div> </div>
                                <div className='button-form background-932790 color-white mt20 mb40' onClick={() => showAccountDeletionClick(true)}>  <div>{t("account_deletion")}</div> </div>
                            </div>
                        </Background>:null}
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
            {state.showAccountDeletionPopup && accountDeletionPopup()}
        </Frame>
    );
}